import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import TopBar from "@/components/TopBar";
import { toast } from "sonner";
import Footer from "@/components/Footer";
import BacktestForm from "@/components/backtest/BacktestForm";
import BacktestResults from "@/components/backtest/BacktestResults";

export default function Backtest() {
  const [symbol, setSymbol] = useState("AAPL");
  const [mode, setMode] = useState("preset");
  const [preset, setPreset] = useState("macd_bull_cross");
  const [rules, setRules] = useState([{ id: 1, indicator: "rsi", op: "lt", threshold: 30 }]);
  const nextRuleId = useRef(2);
  const [hold, setHold] = useState(5);
  const [period, setPeriod] = useState("1y");
  const [volumePref, setVolumePref] = useState("standard");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    try {
      const body = mode === "preset"
        ? { symbol, preset, hold_days: Number(hold), period, volume_pref: volumePref }
        : {
            symbol,
            rules: rules.map((r) => ({ ...r, threshold: Number(r.threshold) })),
            hold_days: Number(hold), period, volume_pref: volumePref,
          };
      const { data } = await api.post("/backtest", body);
      setResult(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Backtest failed");
    } finally { setLoading(false); }
  };

  const setRule = (id, k, v) => setRules((rs) => rs.map((r) => (r.id === id ? { ...r, [k]: v } : r)));
  const addRule = () => setRules((rs) => [...rs, { id: nextRuleId.current++, indicator: "macd_hist", op: "gt", threshold: 0 }]);
  const delRule = (id) => setRules((rs) => rs.filter((r) => r.id !== id));

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <TopBar />
      <div className="px-6 py-5 max-w-6xl mx-auto">
        <div className="micro-label">/ signal backtest</div>
        <h1 className="font-heading text-3xl mt-1 mb-6">Replay Engine</h1>

        <BacktestForm
          symbol={symbol} onSymbolChange={setSymbol}
          hold={hold} onHoldChange={setHold}
          period={period} onPeriodChange={setPeriod}
          volumePref={volumePref} onVolumePrefChange={setVolumePref}
          mode={mode} onModeChange={setMode}
          preset={preset} onPresetChange={setPreset}
          rules={rules} onSetRule={setRule} onAddRule={addRule} onDelRule={delRule}
          loading={loading} onRun={run}
        />

        {result && <BacktestResults result={result} />}
      </div>
      <Footer />
    </div>
  );
}
